/* eslint-disable */

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        checklists: [],
    },
    mutations: {

        setChecklists(state, payload) {
            state.checklists = payload
        },
    },

    actions: {
        async getChecklists({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.get(`/get-checklists/${payload.siteID}`, payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                dispatch('alert/setLoaded', true, {root: true});
                commit('setChecklists', response.data);
            } catch(err) {
                console.log('Error getting Checklists:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        }, 
        
        async getChecklist({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});        
                let response = await axios.get(`/get-checklist/${payload.checklistID}`, payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));  
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting a Checklist:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async createChecklist({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/create-checklist', payload, { crossdomain: true });
                console.log('Response:' + JSON.stringify(response));   
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Checklist created successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error creating a Checklist:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async updateChecklist({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.put(`/update-checklist/${payload.ChecklistID}`, payload, { crossdomain: true });
                console.log('Response:' + JSON.stringify(response));   
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Checklist updated successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error updating checklist:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },
    }
}